import type { AppStateStatus } from "react-native";

export type PictureInPicturePhase = "idle" | "requesting" | "active";

export function shouldPauseLocalPlaybackForAppState({
  appState,
  pictureInPicturePhase,
  platform,
  remotePlaybackActive
}: {
  appState: AppStateStatus;
  pictureInPicturePhase: PictureInPicturePhase;
  platform: string;
  remotePlaybackActive: boolean;
}): boolean {
  if (
    platform === "web" ||
    remotePlaybackActive ||
    pictureInPicturePhase !== "idle"
  ) {
    return false;
  }
  // iOS exposes Home/lock as `inactive` before it reaches `background`.
  // Android's useful lifecycle boundary is `background`.
  return platform === "ios"
    ? appState === "inactive" || appState === "background"
    : appState === "background";
}
